import Enum from 'enum'

export const Icon = new Enum(['WHEAT', 'COW', 'GEAR', 'CUP'])
export const Color = new Enum(['RED', 'PURPLE', 'GREEN', 'BLUE'])

export class Card {
	/**
	 * Create a new card
	 * @param {number} cost
	 * @param {string|EnumItem} icon
	 * @param {string|EnumItem} color
	 * @param {number[]|number} activation
	 * @param {string} description
	 * @param {Player} owner
	 */
	constructor({
		cost = 0,
		icon = Icon.WHEAT,
		color = Color.BLUE,
		activation = [],
		description = '',
		owner,
	}) {
		if(typeof activation === 'number')
			activation = [activation]

		if(typeof color === 'string')
			color = Color.get(color.toUpperCase())

		if(!color)
			throw TypeError('Color is not valid')

		if(typeof icon === 'string')
			icon = Icon.get(icon.toUpperCase())

		if(!icon)
			throw TypeError('Icon is not valid')

		this.cost = cost
		this.activation = activation
		this.description = description
		this.color = color
		this.icon = icon

		if(owner)
			this.setOwner(owner)
	}

	/**
	 * When dice are rolled activate me for owner
	 * @param {number} number
	 * @param {Player=} player
	 */
	rolled(number, player) {
		if(this.activation.indexOf(number) > -1) {
			// BLUE card has owner
			if(this.color === Color.BLUE && this.owner) {
				this.activate()
				return true
			}

			// RED card owned by someone else
			if(this.color === Color.RED && this.owner !== player) {
				this.activate(player)
				return true
			}

			// GREEN or PURPLE card owned by roller
			if(this.color & (Color.GREEN | Color.PURPLE) && this.owner === player) {
				this.activate()
				return true
			}
		}
		return false
	}

	/**
	 * card belongs to a player
	 * @param {Player} player
	 */
	setOwner(player) {
		this.owner = player
		player.cards.push(this)
	}

	/**
	 * Name of card
	 * @return {string}
	 */
	get name() {
		return this.constructor.name.replace(/([a-z])([A-Z])/g, '$1 $2').trim()
	}

	/**
	 * @abstract
	 */
	activate() {}
}
